import cookieService from "@/services/storage/cookie.client";
import { useContextStore } from '@/store/context'
import { useMagasinStore } from "@/store/magasin";
import { usePanierStore } from "@/store/panier";

export default defineNuxtPlugin(async ({ $pinia, $config }) => {

  const contextStore = useContextStore($pinia);
  const magasinStore = useMagasinStore($pinia);
  const panierStore = usePanierStore($pinia);

  let uuid = cookieService.get("uuid");
  if (!uuid) {
    uuid = generateUUID();
    const date = new Date();
    date.setDate(new Date().getDate() + 365);
    cookieService.set("uuid", uuid, {
      expires: date,
      sameSite: "Lax",
      path: "/",
      secure: $config.public.SECURE_COOKIES
    });
  }
  contextStore.setUuid(uuid);

  // pas de création de panier au retour paiement & si le magasin est national
  if (!magasinStore.isNational) {
    await panierStore.initPanier();
  }
})

const generateUUID = () => {
  let d = new Date().getTime();
  if (typeof performance !== 'undefined' && typeof performance.now === 'function') {
    d += performance.now(); // use high-precision timer if available
  }
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = (d + Math.random() * 16) % 16 | 0;
    d = Math.floor(d / 16);
    return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
  });
};
